module.exports = new __parcel__URL__("forms-preview-dark.430156b1.svg").toString();